<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("enterprise") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <div class="tabs is-toggle is-fullwidth" ref="tabs">
          <ul>
            <li
              class="is-active"
              data-tab="general"
              @click="change_active_tab($event, this)"
            >
              <a>
                <i class="info icon" aria-hidden="true"></i>
                <span>{{ $t("general") }}</span>
              </a>
            </li>
            <li
              data-tab="authentication"
              @click="change_active_tab($event, this)"
            >
              <a>
                <i class="key icon" aria-hidden="true"></i>
                <span>{{ $t("authentication") }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="is-fluid" ref="contents">
          <div class="" data-tab="general">
            <form>
              <div class="field">
                <label class="label">{{ $t("name") }}</label>
                <div class="control">
                  <input class="input" type="text" v-model="meta.name" />
                </div>
              </div>
              <!-- <div class="field">
                <label class="label">{{ $t("description") }}</label>
                <div class="control">
                  <textarea
                    class="textarea"
                    v-model="meta.description"
                  ></textarea>
                </div>
              </div> -->
              <div class="field">
                <label class="label">{{ $t("logo") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.settings.logo"
                  />
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("currency") }}</label>
                    <div class="control">
                      <div class="select">
                        <select v-model="meta.settings.currency">
                          <option
                            v-for="(currency, cidx) in currencies"
                            :key="cidx"
                            :value="currency.value"
                          >
                            {{ $t(currency.text) }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("default language") }}</label>
                    <div class="control">
                      <div class="select">
                        <select v-model="meta.settings.default_language">
                          <option value="es">{{ $t("spanish") }}</option>
                          <option value="en">{{ $t("english") }}</option>
                          <option value="fr">{{ $t("french") }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("date format") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.settings.date_format"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("date time format") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.settings.date_time_format"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("time format") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.settings.time_format"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("jwt key") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.settings.system_authentication_jwt_key"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <label class="label">{{ $t("jwt expire time") }}</label>
                  <div class="field has-addons">
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="
                          meta.settings
                            .system_authentication_jwt_expire_time_quantity
                        "
                      />
                    </div>
                    <p class="control">
                      <span class="select">
                        <select
                          v-model="
                            meta.settings
                              .system_authentication_jwt_expire_time_unit
                          "
                        >
                          <option value="m">{{ $t("minute") }}</option>
                          <option value="h">{{ $t("hour") }}</option>
                          <option value="d">{{ $t("day") }}</option>
                        </select>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <generic-dropdown
                      :title="$t('password recovery outbox template')"
                      :placeholder="$t('template')"
                      :is_multiple="false"
                      url="/outbox/template/catalog"
                      name_field="name"
                      value_field="template_id"
                      @change="set_template"
                      ref="template_dropdown"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="is-hidden" data-tab="authentication">
            <div class="field">
              <label class="label">{{ $t("authentication method") }}</label>
              <div class="control">
                <div class="select">
                  <select v-model="meta.settings.authentication_method">
                    <option value="system">{{ $t("system") }}</option>
                    <option value="database">{{ $t("database") }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="
                meta.settings.authentication_method &&
                meta.settings.authentication_method == 'database'
              "
            >
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("engine") }}</label>
                    <div class="control">
                      <div class="select">
                        <select
                          v-model="meta.settings.database_authentication_engine"
                        >
                          <option value="mysql">{{ $t("mysql") }}</option>
                          <option value="mssql">{{ $t("sql server") }}</option>
                          <option value="oracle">{{ $t("oracle") }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("host") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.settings.database_authentication_host"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("database name") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.settings.database_authentication_name"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("port") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.settings.database_authentication_port"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5" v-if="!uuid">
              <h1 class="title is-5">
                {{ $t("new administrator user info") }}
              </h1>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("username") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.admin_user_username"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("email") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.admin_user_email"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("password") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="password"
                        v-model="meta.admin_user_password"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("confirm password") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="password"
                        v-model="meta.admin_user_password_confirm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <pre>{{ meta }}</pre> -->
        </div>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button
            class="button is-primary is-rounded"
            :disabled="is_form_valid"
            @click="save"
          >
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            {{ $t("cancel") }}
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import {
  put,
  get,
  post,
  generate_error_message_text,
  change_active_tab,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import jssha1 from "js-sha1";
import currency_catalog from "../../../../../../common/currency.json";

export default {
  name: "EnterpriseModal",
  components: { GenericDropdown },
  data() {
    return {
      is_shown: false,
      meta: { settings: {} },
      uuid: "",
      error: "",
    };
  },
  computed: {
    is_form_valid() {
      let v = this;
      return (
        !v.meta.name ||
        (!v.uuid &&
          (!v.meta.admin_user_username ||
            !v.meta.admin_user_email ||
            !v.meta.admin_user_password ||
            v.meta.admin_user_password !=
              v.meta.admin_user_password_confirm)) ||
        !v.meta.settings.system_authentication_jwt_expire_time_unit ||
        !v.meta.settings.system_authentication_jwt_expire_time_quantity ||
        !v.meta.settings.system_authentication_jwt_key
      );
    },
    currencies() {
      return Object.keys(currency_catalog).map((key) => {
        return {
          value: key,
          text: currency_catalog[key].name,
        };
      });
    },
  },
  methods: {
    change_active_tab: change_active_tab,
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
    },
    edit_mode(uuid) {
      let v = this;
      v.set_initial_state();
      get("/system/enterprise", { uuid: uuid })
        .then((enterprise) => {
          v.meta = enterprise;

          if (v.meta.settings.password_recovery_outbox_template_id)
            v.$refs.template_dropdown.set_value(
              v.meta.settings.password_recovery_outbox_template_id
            );

          v.uuid = uuid;
          v.is_shown = true;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.uuid) {
        let obj = { ...v.meta };
        if (obj.admin_user_password)
          obj.admin_user_password = jssha1(obj.admin_user_password);
        put("/system/enterprise", obj)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        let obj = { ...v.meta };
        obj.uuid = v.uuid;
        post("/system/enterprise", obj)
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      this.meta = {
        name: "",
        description: "",
        settings: {
          authentication_method: "system",
          password_recovery_outbox_template_id: "",
        },
        admin_user_email: "",
        admin_user_password: "",
        admin_user_password_confirm: "",
        admin_user_username: "",
      };
      this.$refs.template_dropdown.clear();
      this.error = "";
      this.uuid = "";
    },
    set_template(template) {
      let v = this;
      v.meta.settings.password_recovery_outbox_template_id = template;
    },
  },
  mounted() {},
};
</script>
<style></style>
